import { render, staticRenderFns } from "./ButtonsCell.vue?vue&type=template&id=0bffdaa1&scoped=true"
import script from "./ButtonsCell.vue?vue&type=script&lang=js"
export * from "./ButtonsCell.vue?vue&type=script&lang=js"
import style0 from "./ButtonsCell.vue?vue&type=style&index=0&id=0bffdaa1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bffdaa1",
  null
  
)

export default component.exports